export default "__VITE_ASSET__CQLwJp_g__"